import React from "react";
import Preloader from "../../helper/Preloader"; 
import FooterOne from "../../components/FooterOne";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
  import VendorsListDisplayTwoAmazon from "../../componentsAmazon/VendorsListDisplayTwoAmazon";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";

const ProductSampleStorePage = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

} 
      {/* HeaderOneCustomer */}
      
      <HeaderOneCustomer category={true} />
 

      {/* VendorsListDisplayTwoAmazon */}
      <VendorsListDisplayTwoAmazon />
 
 
      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default ProductSampleStorePage;
